export const onlyOneOf = (array) => {
  return array.filter((el) => el).length === 1
}
